<template>
  <div class="forbidden-wrapper">
    <div class="forbidden">
      <img src="~@/assets/img/access-forbidden.svg">
      <h6>
        Access to page is forbidden
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageForbidden',
};
</script>
